import { Box, Typography, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CourseEvaluationAlert from './CourseEvaluationAlert'
import CourseEvaluationHeader from './CourseEvaluationHeader'
import Courses from './Courses'
import { getSlotData } from '../../store/slices/distributionPlanSlice/selectors'
import { useParams } from 'react-router-dom'
import { useAppDispatch } from '../../store'
import { getSlotApi } from '../../store/slices/distributionPlanSlice/apis'
import { isEmpty } from 'lodash'
import { resetState } from '../../store/slices/distributionPlanSlice'
import ROUTES from '../../consts/paths'
import { type CustomBreadcrumbT } from '../../utils/BreadcrumbDataPreparation'
import LoadingPageV2 from '../../pages/LoadingPageV2'
import PAGE_TITLES from '../../consts/titles'
import GenericButton from '../../components/GenericButton'
import { ButtonType } from '../../components/GenericButton/styles'
import GenericModal from '../../components/GenericModal'
import SlotEmailSettingsFeature from '../SlotEmailSettingsFeature'
import { getPagePermissions } from '../../store/slices/roleSlice/selectors'
import { PreparedRouteKeys } from '../../hooks/useAllowedPath'
import SyncSectionModal from './SyncSectionModal'

const CoursesAndEnrollment: React.FC = () => {
  const slot = getSlotData()
  const permissions = getPagePermissions()
  const [modalOpen, setModalOpen] = useState(false)
  const [courseSectionsModal, setCourseSectionsModal] = useState<boolean>(false)

  const breadcrumbPrefixList: CustomBreadcrumbT[] = [{ title: PAGE_TITLES.DISTRIBUTION_SERIES, path: ROUTES.DISTRIBUTION_SERIES }, { title: slot?.title ?? '', path: ROUTES.COURSE_AND_ENROLLMENT }]

  const isLoading = isEmpty(slot)
  const { id } = useParams()

  const dispatch = useAppDispatch()

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      try {
        await dispatch(getSlotApi({ urlId: id }))
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    void fetchData()
    return () => {
      dispatch(resetState())
    }
  }, [dispatch, id])

  if (isLoading) {
    return <LoadingPageV2 title={PAGE_TITLES.SURVEY_DISTRIBUTION} />
  }

  const emailEdit = permissions?.includes(PreparedRouteKeys.SlotEmailSettingsPage)
  const isAutoImportActive = slot.isCourseAttributeFilterActive || slot.isReportingHierarchyFilterActive || slot.isSyncAllSectionsForTermActive

  const params = new URLSearchParams(window.location.search)
  const isNavigatePresent = params.has('navigate')

  return (
    <>
      <GenericModal
        isOpen={modalOpen}
        title={'Survey Project Email Settings'}
        onClose={() => { setModalOpen(false) }}
        maxWidth='sm'
        action={false}
      >
        <SlotEmailSettingsFeature slotId={slot.slotId} handleCloseModal={() => { setModalOpen(false) }} />
      </GenericModal>

      <Box display='flex' flexDirection='column' gap={6}>
        <CourseEvaluationHeader breadcrumb={breadcrumbPrefixList} slot={slot} />
        <CourseEvaluationAlert slot={slot} />

        <Box display='flex' alignItems="center" justifyContent='flex-end' gap={2}>
          <GenericButton
            key="confirmButton"
            buttonType={ButtonType.Primary}
            label={`Sync Course Sections (${isAutoImportActive ? 'On' : 'Off'})`}
            onClick={() => {
              setCourseSectionsModal(true)
            }}
            fontWeight="600"
            type="button"
            disabled={isNavigatePresent}
          />

          {emailEdit &&
            <GenericButton
              key="confirmButton"
              buttonType={ButtonType.Primary}
              label={'Email Settings'}
              onClick={() => {
                setModalOpen(true)
              }}
              fontWeight="600"
              type="button"
              disabled={isNavigatePresent}
            />
          }
        </Box>

        <Courses slot={slot} />

        {
          courseSectionsModal && <SyncSectionModal setCourseSectionsModal={setCourseSectionsModal} courseSectionsModal={courseSectionsModal} slot={slot} />
        }
      </Box>
    </>
  )
}

export default CoursesAndEnrollment
